export const formatDate = (date: string | Date, language: string): string => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";

    const day = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();

    if (language === "es") {
        return `${day}-${month}-${year}`;
    }

    // Default (en) -> YYYY-MM-DD
    return `${year}-${month}-${day}`;
};

/**
 * The YYYY-MM-DD key of a date's local calendar day (today by default).
 * Unlike `toISOString().slice(0, 10)`, which gives the UTC day and is off by
 * one around midnight.
 */
export const toLocalDateKey = (date: Date = new Date()): string => {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    return `${date.getFullYear()}-${month}-${day}`;
};

/**
 * A date and time for people to read, in their language: "lun, 12 sept 2026,
 * 10:00" in Spanish, "Mon, Sep 12, 2026, 10:00 AM" in English. For pickers and
 * labels, where an ISO timestamp is noise.
 */
export const formatHumanDateTime = (date: string | Date, language: string): string => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d.getTime())) return "";

    return new Intl.DateTimeFormat(language, {
        weekday: "short",
        day: "numeric",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    }).format(d);
};
